<template>
    <p-card class="card">
      <template #content>
        <div class="p-fluid p-formgrid p-grid">
              
     
        <div  class="p-field p-col-12 p-md-8">
            <label>Simulate Role</label>
            <p-multiselect :filter="true" v-model="form.role" :options="roles" optionValue="code" optionLabel="label" placeholder="Select roles"  display="chip"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label >Username</label>
          <p-text
            v-model.trim="form.username"
            type="text"
          />
    
        </div>

        <div class="p-field p-col-12">
            <label >Branch</label>
            <p-dropdown
                v-model="form.branch"
                :options="branches"
                optionLabel="label"
                optionValue="code"
                placeholder="Select a branch"
                :filter="true" filterPlaceholder="Search by branch name."
            />
        </div>

                  
          <!-- End: 2nd Row  -->
          <!-- Start: 3rd Row Create & Cancel & Draft buttons -->
          <div class="p-field p-col-12">
            <p-button v-on:click="submitForm">
                Apply
            </p-button
            >
          </div>
          <!-- End: 3rd Row -->
        </div>
      </template>
    </p-card>
  </template>
  
  <script lang="ts">
  import { base } from "@/misc/base";
  import { Options, Vue } from "vue-class-component";
  
  @Options({})
  export default class SandBox extends base {
    form: any = {}
    roles  = []
    branches = []

    submitForm(){
        window.localStorage["roles"] = JSON.stringify(this.form.role)
        window.localStorage["email"] = this.form.username
        window.localStorage["branch"] = this.form.branch
       
        window.location = "" as any
    }

    created(){
        const roles = window.localStorage["roles"]
        this.form.role = JSON.parse(roles ? roles : '[]')
        this.form.username = window.localStorage["email"]
        this.form.branch = window.localStorage["branch"]

        const { simforce } = this.store.state

        simforce
        .get("/masters/user_role")
        .then((response) => {

            this.roles = response.data.results

        })
        .catch((error) => {
            console.error(error);
        });

        simforce
        .get("/branches")
        .then((response) => {

            this.branches = response.data.results.map((el : any) => {

              el.code = el._id
              el.label = el.name
              
              return el
            })
        })
        .catch((error) => {
            console.error(error);
        });
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  